import { Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-project-nav-bar',
  templateUrl: './project-nav-bar.component.html',
  styleUrls: ['./project-nav-bar.component.scss']
})
export class ProjectNavBarComponent {
  @ViewChild('sidenav') sidenav!: MatSidenav;

  isHandset$: Observable<boolean> = this.bp.observe(Breakpoints.Handset)
      .pipe(map(r => r.matches), shareReplay());

  title : string;

  constructor(private bp: BreakpointObserver) {


  }

  setTitle(title: string) : void {
    this.title = title;
  }
}
